import { useSyncExternalStore } from "react";

const KEY = "ccm_basket";
const empty = { subs: [], reports: [] };
let state = (() => { try { return { ...empty, ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return empty; } })();
const subs = new Set();
const set = (next) => { state = next; localStorage.setItem(KEY, JSON.stringify(next)); subs.forEach((f) => f()); };

window.addEventListener("storage", (e) => { if (e.key === KEY) { try { state = { ...empty, ...JSON.parse(e.newValue) }; } catch { state = empty; } subs.forEach((f) => f()); } });

export const basket = {
  addSubs(module, products, regions) {
    const rest = state.subs.filter((s) => !(s.module === module && products.includes(s.product)));
    set({ ...state, subs: [...rest, ...products.map((product) => ({ module, product, regions }))] });
  },
  addReport(id, title) {
    if (!state.reports.some((r) => r.id === id)) set({ ...state, reports: [...state.reports, { id, title }] });
  },
  removeSub(module, product) { set({ ...state, subs: state.subs.filter((s) => !(s.module === module && s.product === product)) }); },
  removeReport(id) { set({ ...state, reports: state.reports.filter((r) => r.id !== id) }); },
  clear() { set(empty); },
  replace(next) { set({ subs: next.subs || [], reports: next.reports || [] }); },
};

export const toBasketBody = (b) => ({ subs: b.subs.map((s) => ({ module: s.module, products: [s.product], regions: s.regions })), reports: b.reports.map((r) => r.id) });

export function useBasket() {
  const b = useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
  return { ...b, count: b.subs.length + b.reports.length };
}
